import React, { useContext } from "react";
import TrackContext from "../../contexts/track-context";
import { ReactComponent as Play } from "../../assets/play.svg";
import { ReactComponent as Pause } from "../../assets/pause.svg";
import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder.svg";
import { ReactComponent as GetAppIcon } from "../../assets/download.svg";
import { CardContent, CircularProgress, Menu, MenuItem } from "@material-ui/core";
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";
import API from "../../services/api";
import { ReactComponent as ThumbPrint } from "../../assets/auto_fix_high_black_18dp.svg";
import CookieManager from "../../services/CookieManager";
import { useHistory } from "react-router-dom";
import Helper from "../../services/helper";
import Constants from "../../services/constants";
import SvgInline from "../../pure-components/SvgInLine";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";

export default function AlternateTracks(props) {
  let trackContext = useContext(TrackContext);
  // console.log("alternate tracks  : ", props)
  // return(<></>)
  return (
    <>
      {props.alternateVersions.map((alternateVersion, i) => (
        <div 
          className="flex w-full flex-col lg:flex-row items-center border-b border-gray-300 py-2 " 
          key={alternateVersion.ID}
        >
          {/* Play Button + Track Info */}
          <div className="flex flex-col lg:flex-row items-start lg:items-center  w-full lg:w-1/2 lg:justify-between space-y-2 lg:space-y-0 lg:space-x-2">
            <div className="flex  w-full">
              <div className="flex-1 flex">
            <div className="p-1 flex  ">
              <button
                aria-label="Play or Pause"
                className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors border border-gray-400 shadow-sm flex items-center justify-center"
                onClick={() => props.playTrack({trackId : alternateVersion.ID, 
                  title : alternateVersion.DisplayTitle || alternateVersion.Name, 
                  description : alternateVersion.Comment,
                  albumId : alternateVersion.AlbumID, 
                  album : props.albumName,
                  duration : alternateVersion.LengthSeconds,
                  bpm : alternateVersion.bpm,
                  artistName : alternateVersion.Artist,
                  isVersion : true
                })}
              >
                {trackContext.playPause && alternateVersion.ID === trackContext.currentTrackDetail.id ? (
                  <Pause className="w-6 h-6 lg:w-8 lg:h-8  text-gray-700" />
                ) : (
                  <Play className="w-6 h-6 lg:w-8 lg:h-8 text-gray-700" />
                )}
              </button>
            </div>
            
            
              <div className="w-full lg:w-auto overflow-hidden  truncate ">
              <div className="font-semibold text-xs lg:text-sm text-gray-800">
                {alternateVersion?.DisplayTitle?.length > 20 
                  ? alternateVersion?.DisplayTitle.substring(0, 20) + '...' 
                  : alternateVersion?.DisplayTitle}
              </div>
                <div className="text-xs  lg:text-sm text-gray-600 truncate">
                  {alternateVersion?.Artist}
                </div>
              </div>
              </div>
              <div className="text-gray-600 text-xs lg:text-sm w-full lg:w-1/3  text-right pr-1 lg:pr-0 lg:text-left  ">
                {alternateVersion?.Version}
              </div>
            </div>
          </div>

        <div className="flex flex-col lg:flex-row items-center w-full lg:w-1/2  space-y-2 lg:space-y-0 lg:space-x-2">
          {/* Waveform */}
          <div className="w-full lg:w-3/5 flex justify-center md:justify-start py-1">
            {alternateVersion.ID?.length > 0 && 
            <img
              src={Helper.getWaveformURL(alternateVersion.ID)}
              alt=""
              className="w-full"
              loading="lazy"
            />}
            <SvgInline url={alternateVersion.waveform} width="100%" />
          </div>

        <div className="flex justify-around items-center lg:justify-end w-full lg:w-auto ">
            {/* BPM & Duration */}
            <div className="w-1/2   flex justify-around  text-gray-600 text-sm">
            <span>{Math.round(alternateVersion.Bpm)} BPM</span>
            <span>{alternateVersion.LengthSeconds && new Date(alternateVersion.LengthSeconds * 1000).toISOString().substr(14, 5)}</span>

          </div>
        {/* Action Icons */}
        <div className="w-1/2  flex justify-center items-center  space-x-2 p-2 ">
            {/* Removing for now, as harmix only processed the main tracks */}
            {/* <ThumbPrint
              className="cursor-pointer hover:scale-105 transition transform w-6 h-6 lg:w-8 lg:h-8"
              onClick={() => props.magicWandSearch({ 
                id: alternateVersion.ID, 
                title: alternateVersion?.DisplayTitle || alternateVersion?.Name,
                albumId : alternateVersion.AlbumID, 
                artist : alternateVersion.Artist, 
                duration : alternateVersion.LengthSeconds
              })}
            /> */}
            {props?.favs?.includes(alternateVersion.ID) ? (
              props.favingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> :             
              <FavoriteIcon
                onClick={() => props.handleAddTrackToFavorites({trackId : alternateVersion.ID, 
                  title : alternateVersion.DisplayTitle || alternateVersion.Name, 
                  description : alternateVersion.Comment,
                  albumId : alternateVersion.AlbumID, 
                  album : props.albumName,
                  duration : alternateVersion.LengthSeconds,
                  bpm : alternateVersion.bpm,
                  artistName : alternateVersion.Artist})}
                className="cursor-pointer text-red-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
              />
            ) : (
              props.favingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> :             
              <UnFavoriteIcon
                onClick={() => props.handleAddTrackToFavorites({trackId : alternateVersion.ID, 
                  title : alternateVersion.DisplayTitle || alternateVersion.Name, 
                  description : alternateVersion.Comment,
                  albumId : alternateVersion.AlbumID, 
                  album : props.albumName,
                  duration : alternateVersion.LengthSeconds,
                  bpm : alternateVersion.bpm,
                  artistName : alternateVersion.Artist})}
                className="cursor-pointer text-gray-600 hover:text-red-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
              />
            )}
            <CreateNewFolderIcon
              onClick={() => props.handleProjectModal({trackId : alternateVersion.ID, albumId : alternateVersion.AlbumID, artworkRef : Helper.getArtworkURL(alternateVersion.AlbumID), audioRef : Helper.playTrackURL(alternateVersion.ID)})}
              className="cursor-pointer text-gray-700 hover:text-blue-600 hover:scale-110 mt-3 transition w-8 h-8 lg:w-8 lg:h-8"
            />
            {props.download?.includes(alternateVersion.ID) ? (
              props.downloadingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> :   
              <Activedownload
                onClick={() => props.downloadTrack(alternateVersion.ID)}
                className="cursor-pointer text-gray-700 hover:text-blue-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
              />
            ) : (
              props.downloadingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> :   
              <GetAppIcon
                onClick={() => props.downloadTrack(alternateVersion.ID)}
                className="cursor-pointer text-gray-700 hover:text-blue-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
              />
            )}
          </div>
        </div>
      
        </div>
        </div>
      ))}

    </>
  );
}
